import dynamic from 'next/dynamic';

const LottieAnimation = dynamic(() => import('./LottieAnimation.client'), {
	ssr: false,
	loading: () => null,
});

export default LottieAnimation;

